import { Box } from '@mui/material';

// ─── Colour palette per status variant ───────────────────────────────────────

const PALETTE = {
    success: { bg: '#dcfce7', fg: '#15803d', border: '#bbf7d0' }, // Delivered
    error:   { bg: '#fef2f2', fg: '#dc2626', border: '#fecaca' }, // RTO
    warning: { bg: '#fffbeb', fg: '#b45309', border: '#fde68a' }, // NDR / Undelivered
    info:    { bg: '#eff6ff', fg: '#2563eb', border: '#bfdbfe' }, // In-transit / default
    default: { bg: '#f9fafb', fg: '#6b7280', border: '#e5e7eb' }, // Cancelled / unknown
};

function resolveVariant(status) {
    if (!status) return 'default';
    const s = String(status).toUpperCase();
    if (s === 'DELIVERED') return 'success';
    if (s.startsWith('RTO')) return 'error';
    if (s.includes('NDR') || s.includes('UNDELIVERED')) return 'warning';
    if (s.includes('CANCEL')) return 'default';
    return 'info';
}

/**
 * Compact, reusable status chip.
 *
 * Props:
 *   status  string   — raw status string (e.g. "IN_TRANSIT", "RTO_INITIATED")
 *   size    'sm'|'xs' — 'sm' is default; 'xs' for very tight spaces
 */
export default function StatusChip({ status, size = 'sm' }) {
    if (!status) return (
        <Box component="span" sx={{ fontSize: '12px', color: 'text.disabled' }}>—</Box>
    );

    const p = PALETTE[resolveVariant(status)];
    const isXs = size === 'xs';

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: isXs ? '5px' : '8px',
                py: isXs ? '2px' : '3px',
                borderRadius: '4px',
                fontSize: isXs ? '10px' : '10.5px',
                fontWeight: 700,
                letterSpacing: '0.3px',
                lineHeight: 1.4,
                textTransform: 'uppercase',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                userSelect: 'none',
                bgcolor: p.bg,
                color: p.fg,
                border: `1px solid ${p.border}`,
            }}
        >
            {String(status).replace(/_/g, ' ')}
        </Box>
    );
}
